import { useState } from "react";
import { useSelector } from "react-redux";
import { selectShowOptimePopupOnCheckout } from "../../../redux/selectors/cartSelectors";
import { redirectToUrl } from "../../../../utils/url/urlUtils";
import OptimeInfoPopup from "../OptimeInfoPopup";
import { CHECKOUT_PAGE } from "../../../../utils/url/staticUrls";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/components/Button/Button";

export const CheckoutButton = ({ disabled }: { disabled?: boolean }) => {
  // SCHAEFF-7926 - So you cannot click twice..
  const [clicked, setClicked] = useState(false);
  const { t } = useTranslation();

  const [showOptimeInfoPopup, setShowOptimeInfoPopup] = useState<boolean>(false);

  const showOptimePopupOnCheckout = useSelector(selectShowOptimePopupOnCheckout);

  const goToCheckout = () => {
    setClicked(true);
    redirectToUrl(CHECKOUT_PAGE);
  };

  const clickedHandler = () => {
    showOptimePopupOnCheckout ? setShowOptimeInfoPopup(true) : goToCheckout();
  };
  return (
    <>
      <Button disabled={disabled || clicked} onClick={clickedHandler} data-test-id={"btn-checkout"}>
        {t("cartPage.btn.checkout")}
      </Button>
      {showOptimeInfoPopup && (
        <OptimeInfoPopup
          onClose={() => setShowOptimeInfoPopup(false)}
          closeButton={
            <Button
              data-test-id={"cart-optime-info-btn-back"}
              variant={"text"}
              onClick={() => setShowOptimeInfoPopup(false)}
            >
              {t("checkoutPage.btn.back")}
            </Button>
          }
          continueButton={
            <Button data-test-id={"cart-optime-info-btn-continue"} onClick={goToCheckout}>
              {t("cartPage.optimePopup.btn.proceed")}
            </Button>
          }
        />
      )}
    </>
  );
};
